// extracted by mini-css-extract-plugin
module.exports = {"title":"legal-module--title--2fMqr","date":"legal-module--date--QHRNU","container":"legal-module--container--2TJmF"};